import { createFileRoute } from "@tanstack/react-router";
import { PrivacyContent } from "@/components/content/PrivacyContent";

export const Route = createFileRoute("/privacy")({
  head: () => ({
    meta: [
      { title: "Privacy Policy — Recovery Trauma™" },
      {
        name: "description",
        content:
          "How Recovery Trauma™ collects, uses, stores, shares and deletes personal information — lawful bases, retention, international transfers and your UK GDPR rights.",
      },
      { property: "og:title", content: "Privacy Policy — Recovery Trauma™" },
      {
        property: "og:description",
        content:
          "Our commitments to privacy, data protection, and your rights as a Recovery Trauma™ user.",
      },
      { property: "og:url", content: "https://recoverytrauma.com/privacy" },
      { property: "og:type", content: "website" },
      { name: "twitter:card", content: "summary_large_image" },
    ],
    links: [{ rel: "canonical", href: "https://recoverytrauma.com/privacy" }],
  }),
  component: PrivacyContent,
});
